import React, { HTMLAttributes, PropsWithChildren } from 'react';

import styles from './styles.module.css';

export interface DotPaginationProps
  extends PropsWithChildren<HTMLAttributes<HTMLElement>> {}

export const DotPagination: React.FC<DotPaginationProps> = ({
  children,
  ...props
}) => {
  return (
    <div className={styles.dotPagination} {...props}>
      {children}
    </div>
  );
};
